/**
 * Checks if passed color is in rgb/rgba format.
 * @param {String} color
 * @return {Boolean}
 */
const isRgbFormat = (color) => /^(rgb)(a?)[(]\s*([\d.]+\s*%?)\s*,\s*([\d.]+\s*%?)\s*,\s*([\d.]+\s*%?)\s*(?:,\s*([\d.]+)\s*)?[)]$/.test(color);

module.exports = isRgbFormat;
